import { createAction, props } from '@ngrx/store';
import { ClickType, Notification } from './notification.state';

/**
 * Shows a message with an "OK" and "Cancel" button.
 */
export const showNotificationAction = createAction('[Notifications] Show', props<Notification>());

/**
 * Remove a notification.
 */
export const closeNotificationAction = createAction(
	'[Notification] Close',
	props<{ clicked?: ClickType; data?: any }>()
);

/**
 * Remove a notification.
 */
export const removeNotificationAction = createAction('[Notifications] Remove');
